import { c as _c } from "react/compiler-runtime";
export function Empty(t0) {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <div className="flex h-[50vh] w-full flex-col items-center justify-center"><p>{message}</p></div>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}